import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import SupplierCreate from '../../components/Supplier/SupplierCreate';

const SupplierCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <SupplierCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default SupplierCreatePage;